import React from "react";
import "./AdminPage.css";
import { ShieldCheck } from "lucide-react";
import useAccess from "../hooks/useAccess.jsx";
import { resolvePageSurfaceWidthClassName } from "../utils/pageSurfaceLayout.js";
import WorkspacePageHeader from "./WorkspacePageHeader.jsx";
import SystemConfigAccessSection from "./SystemConfigAccessSection.jsx";
import { joinClasses } from "./resultsPrimitives/shared.js";

const ADMIN_SURFACE_WIDTH_CLASS_NAME = resolvePageSurfaceWidthClassName("admin");

export default function AdminPage() {
  const { access } = useAccess();

  return (
    <div className={joinClasses(["admin-page mx-auto grid w-full gap-2 px-4 pb-5 pt-0 max-[720px]:gap-2 max-[720px]:px-4", ADMIN_SURFACE_WIDTH_CLASS_NAME])}>
        <WorkspacePageHeader
          icon={ShieldCheck}
          description="Rôles, matrice RBAC et audit d’accès — les réglages moteur restent dans Paramètres système."
          title="Admin"
        />

      <SystemConfigAccessSection access={access} />
    </div>
  );
}
